import { createAction } from "redux-actions";

import * as types from "./types";

export const receiveDealSetup = createAction(
  types.RECEIVE_DEAL_SETUP,
  (data) => data
);
